import { create } from 'zustand'
import { config } from 'config'
import { IClientAuthDTO } from '@hooks/dtos/IClientDTO'

type IActionsProps = {
  setClient: (customer: IClientAuthDTO | undefined) => void
  checkIfHaveSession: () => void
  setSessionId: (value: string) => void
}

type IStoreProps = {
  client: IClientAuthDTO | undefined
  sessionId: string
  actions: IActionsProps
}

export const ZuAuthStore = create<IStoreProps>((set) => ({
  client: undefined,
  sessionId: '',
  actions: {
    setClient: (value) => {
      localStorage.setItem(`@${config.appAgent}:client`, JSON.stringify(value))
      return set(() => ({ client: value }))
    },
    checkIfHaveSession: () => {
      const data = localStorage.getItem(`@${config.appAgent}:client`)
      return set(() => ({ client: data ? JSON.parse(data) : undefined }))
    },
    setSessionId: (value) => {
      return set(() => ({ sessionId: value }))
    },
  },
}))
